import { sendGetRequest } from "services/apiService";
import { UserNotRegisteredTokenError } from "./constants";

interface TokenPayload {
  meetingId: string;
  isCameraOn: boolean;
  isMicrophoneOn: boolean;
}

type TokenResponse =
  | {
      token: string;
      status: true;
    }
  | {
      status: false;
      reason?: string;
      message: string;
    };

export const getRequestURL = (payload: TokenPayload) => {
  const { meetingId, isCameraOn, isMicrophoneOn } = payload;
  const queryString = new URLSearchParams({
    isCameraOn: isCameraOn.toString(),
    isMicrophoneOn: isMicrophoneOn.toString(),
  }).toString();

  return `/daily/${meetingId}/token?${queryString}`;
};

export const dailyTokenRequest = async (
  payload: TokenPayload,
): Promise<string> => {
  const resp = await sendGetRequest<TokenResponse>(getRequestURL(payload));

  if (resp.status === false) {
    if (resp.reason && resp.reason === "user is not registered to event") {
      throw new UserNotRegisteredTokenError(resp.message);
    }

    throw new Error(resp.message);
  }

  return resp.token;
};
